import { useQuery } from "react-query";
import { getWhatsappTemplateByChannel } from "../../../../../../utils/whatsappTemplate";
import { mapTemplates } from "../mappers/template";

export const useGetWhatsappTemplateByChannel = (channelId, name) => {
  return useQuery(
    ["templates", channelId, name],
    async ({ signal }) => {
      const templates = await getWhatsappTemplateByChannel(
        channelId,
        {
          name,
        },
        signal,
      );

      return mapTemplates(templates);
    },
    {
      keepPreviousData: true,
      enabled: !!channelId,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchInterval: false,
    },
  );
};
